<template>
    <div class="flex items-center gap-2">
        <svg
            width="28"
            height="28"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M0.632812 5.6118C1.01406 5.23195 1.53455 5 2.10808 5H31.8885C32.4654 5 32.9892 5.23531 33.3704 5.61852L16.9038 20.2278L0.632812 5.6118Z"
                fill="#3D942F"
            />
            <path
                d="M0 7.13942V25.8632C0 27.0431 0.944831 28.0012 2.10847 28.0012H25.5535L0.633203 5.61328C0.242009 5.99986 0 6.54107 0 7.13942Z"
                fill="#A6E61F"
            />
            <path
                d="M33.9994 25.8623V7.13856C33.9994 6.54356 33.7607 6.00572 33.3728 5.61914L16.9062 20.2284L25.5556 28.0003H31.891C33.0546 28.0003 33.9994 27.0422 33.9994 25.8623Z"
                fill="#59BC1C"
            />
        </svg>
        <span class="text-[17px] font-semibold text-gray-900">ecomail.cz</span>
    </div>
</template>
